import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-sitemap',
    templateUrl: './sitemap.component.html',
    styleUrls: ['./sitemap.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SitemapComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  hash = location.href.slice(location.href.lastIndexOf('#'))
}
